/**
 * One card per enabled metric. Clicking a card makes it the selected metric:
 * the line chart and donut switch to it, and the card keeps a highlighted
 * border (AgencyAnalytics' Explore behaviour).
 */

import type { ReactNode } from 'react';

import { useChangeFormat } from '../../reports/change-format.ts';
import { formatChange, formatValue } from '../../reports/format.ts';
import type { CatalogueMetric, WidgetResult } from '../../reports/reports-api.ts';

export function ExploreCards(props: {
  metrics: CatalogueMetric[];
  result: WidgetResult | null;
  selected: string;
  onSelect: (key: string) => void;
}): ReactNode {
  const changeFormat = useChangeFormat();
  return (
    <div className="ex-cards" role="group" aria-label="Metrics">
      {props.metrics.map((metric) => {
        const entry = props.result?.metrics.find((item) => item.key === metric.key);
        const change = entry?.change
          ? formatChange(entry.change, metric.higher_is_better !== false, {
              as: changeFormat,
              format: metric.format,
            })
          : null;
        const isSelected = metric.key === props.selected;
        return (
          <button
            key={metric.key}
            type="button"
            className={`ex-card${isSelected ? ' on' : ''}`}
            aria-pressed={isSelected}
            onClick={() => props.onSelect(metric.key)}
          >
            <span className="ex-card-label">{metric.label}</span>
            <span className="ex-card-value">
              {props.result ? formatValue(entry?.value ?? null, metric.format) : '…'}
            </span>
            {change && <span className={`ex-change ${change.tone}`}>{change.text}</span>}
          </button>
        );
      })}
    </div>
  );
}
